import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { DataToolDescriptor } from "services/KnowfullyAdminClient";
import useGlobalContext from "hooks/globalData";
import AutocompleteWithQuery, { AutocompleteWithQueryProps } from "components/AutocompleteWithQuery";

type SelectDataToolProps = Omit<
  AutocompleteWithQueryProps<DataToolDescriptor>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectDataTool = (props: SelectDataToolProps) => {
  const { formatMessage: t } = useIntl();
  const { dataToolsService } = useGlobalContext();

  const toolsQuery = useQuery(["dataToolsService.getTools"], () =>
    dataToolsService.getTools(),
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={toolsQuery}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectDataTool;
